import { render } from "./UpdateSuratMasuk.vue?vue&type=template&id=3073aa68&scoped=true"
import script from "./UpdateSuratMasuk.vue?vue&type=script&lang=js"
export * from "./UpdateSuratMasuk.vue?vue&type=script&lang=js"

import "./UpdateSuratMasuk.vue?vue&type=style&index=0&id=3073aa68&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3073aa68"]])

export default __exports__